import { VideoGenerationType } from '@packages/global';
import { useTranslation } from 'react-i18next';

interface VideoTypeTabsProps {
  value: VideoGenerationType;
  onChange: (type: VideoGenerationType) => void;
  disabled?: boolean;
}

const VIDEO_TYPES = [
  VideoGenerationType.TEXT_TO_VIDEO,
  VideoGenerationType.IMAGE_TO_VIDEO,
  VideoGenerationType.KEYFRAME_TO_VIDEO,
  VideoGenerationType.MULTI_IMAGE_TO_VIDEO
];

const TYPE_LABEL_KEYS: Record<VideoGenerationType, string> = {
  [VideoGenerationType.TEXT_TO_VIDEO]: 'common.videoModeT2V',
  [VideoGenerationType.IMAGE_TO_VIDEO]: 'common.videoModeI2V',
  [VideoGenerationType.KEYFRAME_TO_VIDEO]: 'common.videoModeKF2V',
  [VideoGenerationType.MULTI_IMAGE_TO_VIDEO]: 'common.videoModeMI2V'
};

export default function VideoTypeTabs({ value, onChange, disabled }: VideoTypeTabsProps) {
  const { t } = useTranslation('editor');

  return (
    <div className="px-4 pt-3 pb-2">
      <div className="flex gap-1 bg-gray-800/50 rounded-lg p-1">
        {VIDEO_TYPES.map((type) => (
          <button
            key={type}
            onClick={() => onChange(type)}
            disabled={disabled}
            className={`flex-1 px-3 py-1.5 text-xs rounded-md transition-colors disabled:opacity-50 ${value === type
              ? 'bg-gray-700 text-white'
              : 'text-gray-400 hover:text-gray-300 hover:bg-gray-800/50'
              }`}
          >
            {t(TYPE_LABEL_KEYS[type])}
          </button>
        ))}
      </div>
    </div>
  );
}
